import { generateClient } from "aws-amplify/api";

const client = generateClient();

import { list_testimonials } from '@/graphql/queries'

export default {
  data() {
    return {
      testimonialsList: [],
    }
  },
  methods: {
    async fetchTestimonials() {
      try {
        const response = await client.graphql({
          query: list_testimonials,
          variables: {
            input: { 
              testimonial_status:'ALL'
            }
          }
        })
        let responseData = JSON.parse(response.data.list_testimonials)
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.testimonialsList = responseData.data || []
        } else {
          this.testimonialsList = []
        }
        // console.log(this.testimonialsList)
      } catch (error) {
        console.error("Error fetching Testimonials:", error);
        this.testimonialsList = [];
        throw error;
      }
    },
  },
};
